export const iconFontAwesomeHumanitarianSunPlantWilt = (
	<i className="fa-solid fa-sun-plant-wilt"></i>
);
